import React, {useState, useCallback, useMemo, lazy, Suspense} from 'react';
import Menu from '../menu/Menu.component.jsx';
import SmallScreenAlert from './SmallScreenAlert.component';
import translate from '../translations/translations.wrapper.jsx';
import {Outlet} from "react-router-dom";
import ModalRouter from 'components/modals/ModalRouter';
import {ModalContext} from 'components/modals/ModalContext';
import {launchDarkly} from 'utils/launchDarkly';

const VsnNavigation = lazy(() => import('../navigation/VsnNavigation.component'));

// this.props.children is determined by router definition
const PageLayout = (props) => {
    const [modalType, setModalType] = useState(null);
    const [modalProps, setModalProps] = useState(null);

    const toggleModal = useCallback((type, more) => {
        setModalType(type);
        setModalProps(more);
    }, []);

    const useVsnNavigation = launchDarkly.userClient?.variation('fe-vsn-navigation', false);

    const modalValue = useMemo(() => ({toggleModal}), []);
    return (
        <div>
            {useVsnNavigation ? (
                <>
                    <ModalRouter type={modalType} toggleModal={toggleModal} more={modalProps}/>
                    <ModalContext.Provider value={modalValue}>
                        <Suspense fallback={null}>
                            <VsnNavigation>
                                <div className="app-width full-height-container container-fluid">
                                    <Outlet/>
                                    <SmallScreenAlert/>
                                </div>
                            </VsnNavigation>
                        </Suspense>
                    </ModalContext.Provider>
                </>
            ) : (
                <>
                    <Menu location={props.location}/>
                    <ModalRouter type={modalType} toggleModal={toggleModal} more={modalProps}/>
                    <ModalContext.Provider value={modalValue}>
                        <div className="app-width full-height-container container-fluid">
                            <Outlet/>
                            <SmallScreenAlert/>
                        </div>
                    </ModalContext.Provider>
                </>
            )}
        </div>
    )
}
const withTranslations = translate(PageLayout);
export default withTranslations;